import React, { useCallback } from 'react';

import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useActions } from '../../../../../../shared/hooks';
import { stopCloudRecordingAction } from '../../../../features/cloud-recording';
import { ToolbarOption } from '../../toolbar-option';

export function StopCloudRecordingOption() {
    const actions = useActions({ stopCloudRecordingAction });
    const title = i18n('toolbar', 'cloud-recording-stop');
    const onClick = useCallback(() => {
        actions.stopCloudRecordingAction();
        countMetrika('meeting_screen', 'toolbar', 'cloud_recording_stop');
    }, [actions]);

    return <ToolbarOption iconName="pulseRecordingDot" onClick={onClick} title={title} content={title} />;
}
